import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Flex,
  Input,
  useColorModeValue,
  IconButton,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { FaArrowUp } from "react-icons/fa";
import { RiRecordCircleFill } from "react-icons/ri";
import ChatLoader from "./ChatLoader";
import { IoIosAttach } from "react-icons/io";
import { CopyIcon } from "@chakra-ui/icons";
import { ApiResponce } from "../api/aiConfig";

const Chat = () => {
  // Theme variables
  const mainBg = useColorModeValue("gray.50", "#323232");
  const cardBorder = useColorModeValue("gray.300", "#323232");
  const messageColor = useColorModeValue("#000", "#fff");
  const messageBg = useColorModeValue("#fff", "#323232");
  const attachColor = useColorModeValue("#000", "#fff");

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files ? event.target.files[0] : null;
  
    if (!file) {
      setSelectedFile(null);
      setFilePreview(null);
      return;
    }
  
    setSelectedFile(file);
  
    const fileReader = new FileReader();
  
    fileReader.onload = (e) => {
      const result = e.target.result;
  
      if (file.type.startsWith("image/")) {
        setFilePreview(
          <img
            src={result}
            alt="file preview"
            style={{ maxWidth: "200px", borderRadius: "8px" }}
          />
        );
      } else if (file.type === "application/pdf") {
        setFilePreview(
          <a href={result} target="_blank" rel="noopener noreferrer">
            View PDF
          </a>
        );
      } else if (
        file.type === "text/csv" || 
        file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.name.endsWith('.csv')
      ) {
        const fileTypeIcon = file.type === "text/csv" ? (
          <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g opacity="0.5"> <path fill-rule="evenodd" clip-rule="evenodd" d="M14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V10C2 6.22876 2 4.34315 3.17157 3.17157C4.34315 2 6.23869 2 10.0298 2C10.6358 2 11.1214 2 11.53 2.01666C11.5166 2.09659 11.5095 2.17813 11.5092 2.26057L11.5 5.09497C11.4999 6.19207 11.4998 7.16164 11.6049 7.94316C11.7188 8.79028 11.9803 9.63726 12.6716 10.3285C13.3628 11.0198 14.2098 11.2813 15.0569 11.3952C15.8385 11.5003 16.808 11.5002 17.9051 11.5001L18 11.5001H21.9574C22 12.0344 22 12.6901 22 13.5629V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22Z" fill="#1C2"></path> </g> <path d="M11.5092 2.2601L11.5 5.0945C11.4999 6.1916 11.4998 7.16117 11.6049 7.94269C11.7188 8.78981 11.9803 9.6368 12.6716 10.3281C13.3629 11.0193 14.2098 11.2808 15.057 11.3947C15.8385 11.4998 16.808 11.4997 17.9051 11.4996L21.9574 11.4996C21.9698 11.6552 21.9786 11.821 21.9848 11.9995H22C22 11.732 22 11.5983 21.9901 11.4408C21.9335 10.5463 21.5617 9.52125 21.0315 8.79853C20.9382 8.6713 20.8743 8.59493 20.7467 8.44218C19.9542 7.49359 18.911 6.31193 18 5.49953C17.1892 4.77645 16.0787 3.98536 15.1101 3.3385C14.2781 2.78275 13.862 2.50487 13.2915 2.29834C13.1403 2.24359 12.9408 2.18311 12.7846 2.14466C12.4006 2.05013 12.0268 2.01725 11.5 2.00586L11.5092 2.2601Z" fill="#1C2"></path> </g></svg>
        ) : (
          <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g opacity="0.5"> <path fill-rule="evenodd" clip-rule="evenodd" d="M14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V10C2 6.22876 2 4.34315 3.17157 3.17157C4.34315 2 6.23869 2 10.0298 2C10.6358 2 11.1214 2 11.53 2.01666C11.5166 2.09659 11.5095 2.17813 11.5092 2.26057L11.5 5.09497C11.4999 6.19207 11.4998 7.16164 11.6049 7.94316C11.7188 8.79028 11.9803 9.63726 12.6716 10.3285C13.3628 11.0198 14.2098 11.2813 15.0569 11.3952C15.8385 11.5003 16.808 11.5002 17.9051 11.5001L18 11.5001H21.9574C22 12.0344 22 12.6901 22 13.5629V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22Z" fill="#1565c0"></path> </g> <path d="M11.5092 2.2601L11.5 5.0945C11.4999 6.1916 11.4998 7.16117 11.6049 7.94269C11.7188 8.78981 11.9803 9.6368 12.6716 10.3281C13.3629 11.0193 14.2098 11.2808 15.057 11.3947C15.8385 11.4998 16.808 11.4997 17.9051 11.4996L21.9574 11.4996C21.9698 11.6552 21.9786 11.821 21.9848 11.9995H22C22 11.732 22 11.5983 21.9901 11.4408C21.9335 10.5463 21.5617 9.52125 21.0315 8.79853C20.9382 8.6713 20.8743 8.59493 20.7467 8.44218C19.9542 7.49359 18.911 6.31193 18 5.49953C17.1892 4.77645 16.0787 3.98536 15.1101 3.3385C14.2781 2.78275 13.862 2.50487 13.2915 2.29834C13.1403 2.24359 12.9408 2.18311 12.7846 2.14466C12.4006 2.05013 12.0268 2.01725 11.5 2.00586L11.5092 2.2601Z" fill="#1565c0"></path> </g></svg>
        );
        setFilePreview(fileTypeIcon);
      } else {
        setFilePreview(<p>File preview is not available</p>);
      }
    };
  
    fileReader.readAsDataURL(file);
  };

  const handleSendMessage = async () => {
    if (input.trim() === "" && !selectedFile) return;
  
    const userMessage = {
      sender: "user",
      text: input,
      fileName: selectedFile ? selectedFile.name : null,
      filePreview: filePreview,
    };
  
    setMessages((prevMessages) => [...prevMessages, userMessage]);
    setInput("");
    setLoading(true);
  
    try {
      let context = input;
  
      if (selectedFile) {
        const fileText = await selectedFile.text();
        context += `\nContext from file:\n${fileText}`;
        setSelectedFile(null);
        setFilePreview(null);
      }
  
      const responseText = await ApiResponce(context);
      const formattedText = formatText(responseText);
      const botMessage = { sender: "bot", text: formattedText };
      setMessages((prevMessages) => [...prevMessages, botMessage]);
    } catch (error) {
      console.error("Error fetching response from OpenAI:", error);
      const errorMessage = {
        sender: "bot",
        text: "Sorry, something went wrong. Please try again.",
      };
      setMessages((prevMessages) => [...prevMessages, errorMessage]);
    } finally {
      setLoading(false);
    }
  };

  const formatText = (text) => {
    text = text.replace(/\n/g, "<br />");
    text = text.replace(
      /(\*|-)\s(.*?)(<br \/>|$)/g,
      '<ul style="list-style-type: none;"><li style="list-style:none;">$2</li></ul>'
    );
    text = text.replace(
      /\*\*\*(.*?)\*\*\*/g,
      '<span style="font-weight: bold; font-size: 16px;">$1</span>'
    );
    text = text.replace(
      /\*\*(.*?)\*\*/g,
      '<span style="font-weight: bold; font-size: 18px;">$1</span>'
    );
    text = text.replace(
      /\*(.*?)\*/g,
      '<span style="font-weight: bold; font-size: 20px;">$1</span>'
    );

    return text;
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleCopy = (index) => {
    const plainText = messages[index].text.replace(/<[^>]+>/g, "");
    navigator.clipboard.writeText(plainText).then(() => {
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    }).catch((err) => {
      console.error("Failed to copy text:", err);
    });
  };

  return (
    <Container py={4} maxWidth="100%" ps={0}>
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection="column"
        overflowY='hidden'
        // height="85vh"
        borderRadius="lg"
        p={0}
      >
        <Box w="100%" h="650px" overflowY="scroll" maxWidth="3xl" mx="auto" p={4} style={{scrollbarWidth: 'none'}}>
          {messages.map((message, index) => (
            <Flex
              key={index}
              justify={message.sender === "user" ? "flex-end" : "flex-start"}
            >
              <Box
                bg={messageBg}
                color={messageColor}
                px={4}
                py={2}
                w="550px"
                borderWidth={1}
                borderColor={cardBorder}
                borderRadius="lg"
                mb={2}
                position="relative"
              >
                <Text fontSize="xs" fontWeight="bold">
                  {message.sender === "user" ? "You" : "Assistant"}
                </Text>
                <div dangerouslySetInnerHTML={{ __html: message.text }} />
                {message.filePreview && <Box mt={2}>{message.filePreview}</Box>}
                <Tooltip
                  label={copiedIndex === index ? "Copied!" : "Copy"}
                  closeOnClick={false}
                  hasArrow
                  placement="bottom"
                >
                  <IconButton
                    icon={<CopyIcon />}
                    size="sm"
                    position="absolute"
                    top={1}
                    right={1}
                    aria-label="Copy to clipboard"
                    bg="transparent"
                    _hover={{ bg: "transparent" }}
                    onClick={() => handleCopy(index)}
                  />
                </Tooltip>
              </Box>
            </Flex>
          ))}
          {loading && (
            <Flex justify="start" mt={2}>
              <ChatLoader />
            </Flex>
          )}
        </Box>
        <Flex
          position="absolute"
          bottom={10}
          left='23%'
          zIndex="10"
          w="100%"
          maxWidth="3xl"
          mx="auto"
          bg={mainBg}
          p={3}
          borderRadius="50px"
          border={1}
          borderColor={cardBorder}
        >
          <Input
            type="file"
            id="file-upload"
            style={{ display: "none" }}
            onChange={handleFileChange}
            p={0}
          />
          <IconButton
            aria-label="Attach file"
            icon={<IoIosAttach size={25} />}
            mr={2}
            bg="transparent"
            _hover={{ bg: "transparent" }}
            color={attachColor}
            p={0}
            onClick={() => document.getElementById("file-upload").click()}
          />
          <Input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Type your message..."
            p={0}
            border={0}
            outline="none"
            focusBorderColor="transparent"
            mr={2}
          />
          <Button p={0} onClick={handleSendMessage} variant="brand">
            {loading === true ? (
              <RiRecordCircleFill aria-disabled />
            ) : (
              <FaArrowUp />
            )}
          </Button>
        </Flex>
      </Box>
    </Container>
  );
};

export default Chat;
